import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Context } from "../context/AppContext";
import { useContext, useState } from "react";
import pop1 from "../assets/images/pop5.png";
import pop2 from "../assets/images/pop2.png";
import pop3 from "../assets/images/pop3.png";
import pop4 from "../assets/images/pop4.png";

const Home2OurBlog = () => {
  const navigate = useNavigate();
  const [modal, showModal] = useState(false);
  const { setRestaurantId } = useContext(Context);

  const handleOpenModal = () => showModal(true);

  const handleToOrder = (id) => {
    setRestaurantId(id);
    navigate("/online-order");
  };

  return (
    <section className="content-inner overflow-hidden petal-back">
      <div className="container">
        <div className="row">
          {/* Left: Images */}
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 image-grid">
            <img src={pop3} alt="dish" />
            <img src={pop2} alt="dish" />
            <img src={pop4} alt="dish" />
            <img src={pop1} alt="dish" />
          </div>

          {/* Right: Text and CTA */}
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-content">
            <h2 className="text-center text-white">A CHINESE ​FLING</h2>
            <p className="text-white">
              Petals of a Peony was born from a love of all ​things Chengdu,
              Sichuan Province. Our ​founder spent three years in Chengdu and
              fell ​in love with the city and the food. She brought ​to America
              everything she loved — the flavors, ​the feelings, the
              family-style restaurants — so ​that you can get a taste of
              Sichuan, too.
            </p>

            {/* Phone numbers */}
            <div className="text-white mt-3">
              <a
                className="d-block text-decoration-underline fw-semibold mb-1"
                style={{ fontSize: "1.1rem", color: "#fff" }}
                href="tel:+19017078886"
              >
                Cordova: (901)-707-8886
              </a>
              <a
                className="d-block text-decoration-underline fw-semibold mb-1"
                style={{ fontSize: "1.1rem", color: "#fff" }}
                href="tel:+19012076680"
              >
                Overton Square: (901)-207-6680
              </a>
              <a
                className="d-block text-decoration-underline fw-semibold mb-1"
                style={{ fontSize: "1.1rem", color: "#fff" }}
                href="tel:+19016280086"
              >
                小富贵 Little Petals Chinese (Downtown): (901)-628-0086
              </a>
              <a
                className="d-block text-decoration-underline fw-semibold mb-1"
                style={{ fontSize: "1.1rem", color: "#fff" }}
                href="tel:+19016689388"
              >
                小富贵 Little Petals Chinese 2 (Poplar): (901)-668-9388
              </a>
            </div>

            {/* Buttons */}
            <div className="text-center d-flex mt-3 gap-3">
              <button
                className="btn btn-light text-dark fw-semibold w-100 shadow-sm"
                onClick={handleOpenModal}
                style={{
                  borderRadius: 12,
                  backgroundColor: "#fff",
                  border: "none",
                }}
              >
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ─────────────── Location Modal ─────────────── */}
      <Modal
        show={modal}
        onHide={() => showModal(false)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          className="border-0"
          style={{
            backgroundColor: "#fff9f7",
            borderBottom: "1px solid rgba(157,42,0,0.15)",
          }}
        >
          <Modal.Title className="fw-bold text-dark">
            Choose a Location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="bg-white text-dark"
          style={{
            borderRadius: "0 0 1rem 1rem",
          }}
        >
          <div className="container py-3">
            <div className="row gy-4 justify-content-center">
              {[
                {
                  id: 7,
                  title: "Cordova Location",
                  address: "1250 N Germantown Pkwy Cordova, TN 38016",
                  phone: "(901)-707-8886",
                },
                {
                  id: 11,
                  title: "Overton Square Location",
                  address: "2110 Madison Ave Memphis, TN 38104",
                  phone: "(901)-207-6680",
                },
                {
                  id: 40,
                  title: "小富贵 Little Petals Chinese (Downtown)",
                  address: "149 Madison Ave Memphis, TN 38103",
                  phone: "(901)-628-0086",
                },
                {
                  id: 73,
                  title: "小富贵 Little Petals Chinese 2 (Poplar)",
                  address: "5167 Poplar Ave Memphis, TN 38117",
                  phone: "(901)-668-9388",
                },
              ].map((loc, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-5">
                  <div
                    className="border rounded-4 shadow-sm h-100 p-4 text-center"
                    style={{
                      borderColor: "rgba(157,42,0,0.15)",
                      transition: "all 0.3s ease",
                      background: "#fff",
                    }}
                  >
                    <h5 className="fw-bold mb-3 text-dark">{loc.title}</h5>
                    <p className="mb-1">{loc.address}</p>
                    <a
                      href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`}
                      className="d-block mb-3 text-decoration-none text-muted fw-semibold"
                    >
                      {loc.phone}
                    </a>
                    <button
                      onClick={() => handleToOrder(loc.id)}
                      className="btn fw-semibold w-100"
                      style={{
                        backgroundColor: "#9d2a00",
                        color: "#fff",
                        borderRadius: 12,
                        transition: "background-color 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#b83500")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#9d2a00")
                      }
                    >
                      Order Here
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Home2OurBlog;
